export const indexColumns = [
  {
    type: 'name',
    value: 'name',
    label: 'Name',
    isSortable: true,
  },
  {
    type: 'booksCount',
    value: 'booksCount',
    label: 'Number of book(s)',
    isSortable: true,
  },
  {
    type: 'actions',
    value: null,
    label: 'Actions',
    isSortable: false,
  },
];

const sharedConfig = {
  clearable: true,
  variant: 'outlined',
  // DEV NOTE: must be 'false' for 'v-autocomplete'
  hideDetails: true,
};

export const filterConfig = [
  {
    name: 'keyword',
    controlType: 'text',
    label: 'Search',
    prependInnerIcon: 'mdi-magnify',
    ...sharedConfig
  },
];

export default { indexColumns, filterConfig };
